(() => {
  const prepared = new WeakSet();
  const visible = new Set();
  function start(video) {
    if (document.hidden || !visible.has(video) || !video.getClientRects().length) return;
    video.play().catch(() => {});
  }
  const visibility = new IntersectionObserver(entries => {
    entries.forEach(({target: video, isIntersecting}) => {
      if (isIntersecting) { visible.add(video); start(video); }
      else { visible.delete(video); video.pause(); }
    });
  }, {threshold: .05});
  function prepare(video) {
    if (prepared.has(video)) return;
    prepared.add(video);
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.controls = false;
    video.removeAttribute('controls');
    ['muted', 'loop', 'autoplay', 'playsinline', 'webkit-playsinline'].forEach(name => video.setAttribute(name, ''));
    if (video.preload === 'none') video.preload = 'metadata';
    video.classList.add('ss-video-standard');
    const host = video.closest('video-media');
    if (host) { host.setAttribute('autoplay', ''); host.removeAttribute('show-play-button'); }
    ['loadeddata', 'canplay'].forEach(event => video.addEventListener(event, () => start(video)));
    visibility.observe(video);
  }
  function scan(root) {
    if (root.matches?.('video')) prepare(root);
    root.querySelectorAll?.('video').forEach(prepare);
  }
  scan(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan)))
    .observe(document.documentElement, {childList: true, subtree: true});
  document.addEventListener('visibilitychange', () => visible.forEach(video => {
    if (document.hidden) video.pause(); else start(video);
  }));
})();
